// Tiny hash router. URL → { name, code? } and back. No external dep.
// Routes:
//   #              splash
//   #/new          create-game form
//   #/j/<CODE>     join form (code pre-filled)
//   #/lobby/<CODE> lobby live view
//   #/help         "Hoe werkt het?" — static rules (in-game uses a modal instead)

export type Route =
  | { name: 'splash' }
  | { name: 'create' }
  | { name: 'join'; code?: string }
  | { name: 'lobby'; code: string }
  | { name: 'game'; code: string }
  | { name: 'help' };

export function parseRoute(hash: string): Route {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const path = raw.replace(/^\/+/, '');
  if (path === '') return { name: 'splash' };
  if (path === 'new') return { name: 'create' };
  if (path === 'help') return { name: 'help' };

  const join = /^j(?:\/([^/?#]+))?$/.exec(path);
  if (join) {
    const code = join[1]?.toUpperCase();
    return code ? { name: 'join', code } : { name: 'join' };
  }

  const lobby = /^lobby\/([^/?#]+)$/.exec(path);
  if (lobby) return { name: 'lobby', code: lobby[1]!.toUpperCase() };
  const game = /^g\/([^/?#]+)$/.exec(path);
  if (game) return { name: 'game', code: game[1]!.toUpperCase() };

  return { name: 'splash' };
}

export function routeToHash(route: Route): string {
  switch (route.name) {
    case 'splash':
      return '#';
    case 'create':
      return '#/new';
    case 'join':
      return route.code ? `#/j/${route.code}` : '#/j';
    case 'lobby':
      return `#/lobby/${route.code}`;
    case 'game':
      return `#/g/${route.code}`;
    case 'help':
      return '#/help';
  }
}

export function navigate(route: Route): void {
  const hash = routeToHash(route);
  if (window.location.hash !== hash) {
    window.location.hash = hash;
  }
}
